<template>
  <div class="d-flex flex-column align-center">
    <img class="rounded-circle mx-5" v-if="imageBytes && !uploading" v-bind:src="'data:image/jpeg;base64,' + imageBytes"
    width="200px" height="200px" style="object-fit: cover" />
    

    <v-progress-circular v-if="uploading" :rotate="-90" :size="100" :width="15" :value="percentCompleted"
      color="primary">{{ percentCompleted }}</v-progress-circular>

    <v-btn text @click="selectFile"><v-icon color="grey">edit</v-icon></v-btn>

    <input v-on="file" ref="fileSelector" accept="image/*" type="file" class="d-none" @change="uploadFoto">

    <h1>{{ errorMessage }}</h1>

  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["btnLabel", "accept", "title", "fileName", "cedula"],
  data() {
    return {
      errorMessage: "",
      dialog: false,
      snackbar: false,
      uploading: false,
      uploadCompleted: false,
      fileId: null,
      file: null,
      percentCompleted: 0,
      imageBytes: null,
    };
  },
  mounted() {
    this.cargarFoto();
  },
  methods: {
    cargarFoto() {
      axios.get('/persona/' + this.cedula + '/foto').then(res => {
        console.log(res)
        this.imageBytes = res.data.fileContent;
      }).catch(err => console.log(err));
    },
    adjuntar() {

      console.log("--", this.file);

      if (this.file.size == 0) {
        console.log('error this.file', this.file)
        this.errorMessage = "Archivo no valido!";
        return;
      }

      this.uploading = true;
      const config = {
        onUploadProgress: function (progressEvent) {
          this.percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }.bind(this)
      };

      let data = new FormData();
      data.append("file", this.file);
      data.append("fileName", this.fileName);


      axios
        .post("/fotoUpload", data, config)
        .then(() => {
          this.uploading = false;
          this.uploadCompleted = true;
          //this.dialog = false;
          //this.$store.dispatch("showSnack", "Archivo adjuntado con exito!");
          // this.fileId = res.data;
          this.cargarFoto();
        })
        .catch(err => {
          console.log(err);
          this.uploading = false;
          this.uploadCompleted = false;
        });
    },
    volver() {
      // axios
      //   .get("/upload/files")
      //   .then(res => console.log(res))
      //   .catch(err => console.log(err));
      console.log('#volver#', this.uploadCompleted)
      if (this.uploadCompleted) {
        this.$emit("uploaded", { file: this.file, fileId: this.fileId });
      }
      this.dialog = true;
      this.file = null;
      this.fileId = null;
      this.uploading = false;
      this.uploadCompleted = false;
    },
    selectFile() {
      this.dialog = true;
      console.log('*** selectFile')
      console.log('select file', this.$refs)
      console.log('select file', this.$refs.fileSelector.click())
    },
    async uploadFoto(a)  {
      console.log('***** uploadFoto')
      console.log(a.target.files[0])

      let file = a.target.files[0];

      if (!file || file.size == 0) {
        console.log('error this.file', this.file)
        this.errorMessage = "Archivo no valido!";
        return;
      }

      this.uploading = true;
      const config = {
        onUploadProgress: function (progressEvent) {
          this.percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }.bind(this)
      };

      let data = new FormData();
      data.append("file", file);
      data.append("fileName", this.cedula.trim());


      await axios
        .post("/fotoUpload", data, config)
        .then(() => {
          this.uploading = false;
          this.uploadCompleted = true;
          // //this.dialog = false;
          // //this.$store.dispatch("showSnack", "Archivo adjuntado con exito!");
          // this.fileId = res.data;
          // this.volver();
        })
        .catch(err => {
          console.log(err);
          this.uploading = false;
          this.uploadCompleted = false;
        });

      this.cargarFoto()

    }
  }
};
</script>
